/* custom-buttons.js — the shared "Added ✓" state of the add-to-cart buttons (Claude Design handover
   2026-10-08, rule 7.5 and decision 9: 1.5 s everywhere). On Motion's 'ajaxProduct:added'
   (assets/theme.js, success(), dispatched on the product form with detail.addToCartBtn and bubbling
   to document) the button takes .is-added and the label "Added ✓" for 1500 ms, then its wording comes
   back. Only the label span changes: the v3 purchase card appends the price as span.pw-cta-total
   inside the button and hides it by CSS while .is-added. The card's sticky bar and pack sheet mirror
   the class and the label themselves (snippets/rc-widget-v3.liquid syncSticky / syncSheet), so they
   need nothing here. A state, not a motion. A second add inside the window restarts it.
   Skipped when the cart is a page (theme.js navigates) or on the cart page (theme.js reloads).
   theme.js also fires a bare 'ajaxProduct:added' (no detail) right after 'ajaxProduct:error' on a
   422, which the error flag ignores; a bare event without an error falls back to the page's own
   add-to-cart button where one exists (Motion's product form); the stock flex-pdp section fires a
   bare event too but has no such button, so nothing happens there.
   Rebuy widgets: Rebuy runs its own label cycle ("Added ✓" from the admin Language field, 1.5 s) and
   dispatches `rebuy.add` on document with {product, widget}; the listener only adds .is-added to that
   card's button for the same window so assets/custom-rebuy-widgets.css can colour it navy.
   The 183507 bundle (the Wellgard template in snippets/rebuy-extensions.liquid) is the exception:
   Rebuy's bundle logic has no added state and its `rebuy.add` carries the widget's whole products
   ARRAY in detail.product, so the listener sets a flag on the widget's data instead (holdBundle below)
   and the template renders the class and the label from it.
   Loaded deferred from layout/theme.liquid (every page: quick-shop modals add to cart from collection
   and home pages). No dependencies. */
(function () {
  'use strict';

  var ADDED_CLASS = 'is-added';
  var ADDED_TEXT = 'Added ✓';
  var ADDED_MS = 1500;
  var FALLBACK = '.pw-v3 button.add-to-cart, button.add-to-cart[data-add-to-cart]';
  var timers = (typeof WeakMap === 'function') ? new WeakMap() : null;
  var errored = false;

  /* Motion's label span if present; a plain-text button itself; else the first non-empty text node */
  function labelNode(btn) {
    var span = btn.querySelector('[data-add-to-cart-text]');
    if (span) return span;
    if (!btn.firstElementChild) return btn;
    for (var i = 0; i < btn.childNodes.length; i++) {
      var n = btn.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) return n;
    }
    return null;
  }

  function hold(btn) {
    if (!btn || !btn.classList || !timers) return;
    var node = labelNode(btn);
    var entry = timers.get(btn);
    if (entry) {
      clearTimeout(entry.timer);
    } else {
      entry = { prev: node ? node.textContent : '' };
      timers.set(btn, entry);
    }
    if (node) node.textContent = ADDED_TEXT;
    btn.classList.add(ADDED_CLASS);
    entry.timer = setTimeout(function () {
      timers.delete(btn);
      btn.classList.remove(ADDED_CLASS);
      /* restore only if nothing else rewrote the label meanwhile: a variant change sets
         "Sold Out" or the default text itself (theme.js updateCartButton) */
      var now = labelNode(btn);
      if (now && now.textContent === ADDED_TEXT) now.textContent = entry.prev;
    }, ADDED_MS);
  }

  document.addEventListener('ajaxProduct:error', function () {
    errored = true;
    setTimeout(function () { errored = false; }, 0);
  });

  document.addEventListener('ajaxProduct:added', function (event) {
    var settings = (window.theme && window.theme.settings) || {};
    if (settings.cartType === 'page' || document.body.classList.contains('template-cart')) return;
    var btn = (event.detail && event.detail.addToCartBtn) || (!errored && document.querySelector(FALLBACK));
    if (btn) hold(btn);
  });

  /* The bundle's "Added ✓" (183507; step 4 of the Rebuy widgets handover). A class put on the bundle
     button itself would be wiped a moment later: right after `rebuy.add` Rebuy sets its request queue
     back to ready and calls $forceUpdate() on the widget's Vue instance, the button's bound class
     changes (working to idle) and Vue rewrites the class attribute. So the state lives on the widget's
     data object, which is the Vue instance's $data: `wg_added` is set here, the template reads
     `$data.wg_added` for both the `is-added` class and the added_to_cart label, and $forceUpdate()
     renders it (a key added after the instance was created is not reactive). Cleared after the same
     1,500 ms; a second add inside the window restarts it. If the data or the Vue instance is out of
     reach (a Rebuy change), the class goes on the static-class wrapper .rebuy-bundle__actions-buttons,
     which Vue never rewrites (its bound class never changes), and the CSS colours the button from
     there; the label then stays as it is. Rebuy internals this relies on: detail.widget.data (= the
     Vue data) and detail.widget.View.vue (the instance). */
  function holdBundle(widget, root) {
    if (!timers) return;
    var data = widget.data;
    var vue = widget.View && widget.View.vue;
    var viaData = !!(data && typeof data === 'object' && vue && typeof vue.$forceUpdate === 'function');
    var wrap = viaData ? null : root.querySelector('.rebuy-bundle__actions-buttons');
    if (!viaData && !wrap) return;
    var key = viaData ? widget : wrap;
    var entry = timers.get(key);
    if (entry) {
      clearTimeout(entry.timer);
    } else {
      entry = {};
      timers.set(key, entry);
    }
    if (viaData) {
      data.wg_added = true;
      vue.$forceUpdate();
    } else {
      wrap.classList.add(ADDED_CLASS);
    }
    entry.timer = setTimeout(function () {
      timers.delete(key);
      if (viaData) {
        data.wg_added = false;
        /* Rebuy may have rebuilt the Vue instance meanwhile (its reconnect path); render on the live one */
        var live = widget.View && widget.View.vue;
        if (live && typeof live.$forceUpdate === 'function') live.$forceUpdate();
      } else {
        wrap.classList.remove(ADDED_CLASS);
      }
    }, ADDED_MS);
  }

  document.addEventListener('rebuy.add', function (event) {
    var d = event.detail || {};
    if (!d.widget || !d.product || d.widget.id == null) return;
    var root = document.getElementById('rebuy-widget-' + d.widget.id);
    if (!root || root.closest('#rebuy-cart')) return;
    /* the dynamic bundle: detail.product is the array of every product in the widget */
    if (Array.isArray(d.product)) {
      holdBundle(d.widget, root);
      return;
    }
    if (d.product.id == null) return;
    /* the add button, not the quick-view trigger Rebuy renders first in the same actions block */
    var btn = root.querySelector('.rebuy-product-block.product-id-' + d.product.id + ' .rebuy-product-actions .rebuy-button:not(.outline):not(.product-quick-view-button)');
    if (!btn) return;
    btn.classList.add(ADDED_CLASS);
    setTimeout(function () { btn.classList.remove(ADDED_CLASS); }, ADDED_MS);
  });
})();
